import type { Role } from '@eggplant/context'
import {
  SpaceContext,
  realmAccessRoles,
  useKeycloak
} from '@eggplant/context'
import { useContext } from 'react'

const defaultRoles: Role[] = [
  'dai:admin',
  'dai:user'
]

const useSpaceAccess: (allowedRoles?: Role[]) => [boolean] = (
  allowedRoles = defaultRoles
) => {
  const spaceContext = useContext(SpaceContext)
  const { keycloak: keycloakInstance } = useKeycloak()

  // TODO: ETD-7989 to move into "process.env.NODE_ENV === 'test'" section for cypress mockUser
  const getKeycloakAccessibility = () => {
    const realmAccess = !!keycloakInstance.idTokenParsed && keycloakInstance.idTokenParsed.realm_access

    const roles = realmAccess
      ? realmAccess.roles as Role[]
      : []

    const realmRoles = roles.filter(role =>
      realmAccessRoles.includes(role)
    )

    return realmRoles.some(realmRole =>
      allowedRoles.includes(realmRole)
    )
  }

  // let cypress to use mockUser to control access role
  if (import.meta.env.MODE === 'test' || import.meta.env.VITE_IS_AUTH_DISABLED === 'true') {
    return [getKeycloakAccessibility()]
  }

  const spaceRole = spaceContext?.role

  if (!spaceRole) return [false]

  const isAllowed = allowedRoles.includes(spaceRole)

  return [isAllowed]
}

export default useSpaceAccess
